module.exports = __webpack_public_path__ + "img/0-02-0a-f5df8c2ab74fc3f3373994e8656f68bf9e70326ee6cea797318fb7fa39e65e69_cf2387d9.b2c2e170.jpg";